import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import styles from "../../screens/Requirement/Requirement.module.css";
import { PiFileTextLight } from "react-icons/pi";
import { PiFilesLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { changeCandidateStatus, formatDate } from "../../utils/const";
import { useDispatch, useSelector } from "react-redux";
import {
  changeStatusJob,
  getRequirementCandidates,
} from "../../redux/post-requirement/postRequirementSlice";

const statusList = [
  { key: "PENDING_WITH_RECRUITER", label: "Pending with Recruiter" },
  { key: "QUESTION_BY_CANDIDATE", label: "Question by Candidate" },
  { key: "INTERESTED_BY_CANDIDATE", label: "Interested by candidate" },
  { key: "1st_ROUND_OF_INTERVIEW", label: "1st round intro" },
  { key: "2nd_ROUND_OF_INTERVIEW", label: "2nd round intro" },
  { key: "3rd_ROUND_OF_INTERVIEW", label: "3rd round intro" },
  { key: "4th_ROUND_OF_INTERVIEW", label: "4th round intro" },
  { key: "REJECTED", label: "Rejected" },
  { key: "SELECTED", label: "Selected" },
];

const SalesRecruiter = ({
  image,
  date,
  name,
  skill,
  location,
  rate,
  btn1,
  btn2,
  candidate,
  row,
  requirementLoading,
  setCandidateData,
  setJobDetailsData,
  handleShowCandidateDetails,
}) => {
  const [open, setOpen] = useState(false);
  const [btnsName, setBtnsName] = useState("");
  const [getSelectedIndexName, setGetSelectedIndexName] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const requirementStatus = useSelector(
    (state) => state.postrequirement.candidateStatus
  );

  const handleSelect = (text) => {
    setBtnsName(text);
    handleClickOpen();
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnClickStatusChange = () => {
    let userData = {
      progress_data: {
        apply_status: btnsName,
      },
    };
    let userID = candidate?.progress[0]?.apply_id;
    dispatch(changeStatusJob({ userData, userID }));
  };

  useEffect(() => {
    if (requirementStatus === "change_candidate_status") {
      let userID = row?.job_id;
      dispatch(getRequirementCandidates(userID));
      handleClose();
    }
  }, [requirementStatus]);

  useEffect(() => {
    setBtnsName(candidate?.progress[0]?.apply_status);
    setGetSelectedIndexName(candidate?.progress[0]?.apply_status);
  }, [candidate]);

  const buttonColor = btn2 === "Viewed" ? "#4285f4" : "#3856a6";
  const getSelectedIndex = () =>
    statusList.findIndex((item) => item.key === getSelectedIndexName);
  return (
    <Box
      className={styles.recruiter_job_post}
      sx={{ border: "1px solid #f5f5f5" }}
    >
      <Box>
        <span>
          <Typography>
            Date:{" "}
            <b>{date !== undefined && date !== null && formatDate(date)}</b>
          </Typography>
          <Typography>
            Candidate:{" "}
            <b
              onClick={() => {
                handleShowCandidateDetails();
                setCandidateData(candidate);
                setJobDetailsData(row);
              }}
              style={{ cursor: "pointer", textDecoration: "underline" }}
            >
              {name}
            </b>
          </Typography>
          <Typography>
            Job Profile: <b>{skill}</b>
          </Typography>
          <Typography sx={{ margin: "0 !important" }}>
            Location: <b>{location}</b>
          </Typography>
        </span>
      </Box>

      <Box sx={{ alignItems: "end", flexDirection: "column", width: "23%" }}>
        <a
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            textDecoration: "none",
            color: "#374151",
          }}
          href={candidate?.candidate_resume_profile?.resume}
          target="_blank"
        >
          <Typography>
            <b>Resume</b> <PiFileTextLight fontSize="26px" />
          </Typography>
        </a>
        <span>
          {candidate?.progress?.length === 0 ? (
            <button
              onClick={() => {
                handleShowCandidateDetails();
                setCandidateData(candidate);
                setJobDetailsData(row);
              }}
              style={
                requirementLoading === "loading"
                  ? {
                      padding: "7px 40px",
                    }
                  : {
                      backgroundColor: buttonColor,
                      alignSelf: "flex-end",
                      marginTop: "30px",
                    }
              }
            >
              {requirementLoading === "loading" ? (
                <CircularProgress size={30} sx={{ color: "#fff" }} />
              ) : (
                btn1
              )}
            </button>
          ) : (
            // <span className="btn-group" style={{ marginLeft: "10px" }}>
            //   <button
            //     type="button"
            //     className="dropdown-toggle"
            //     data-toggle="dropdown"
            //     aria-haspopup="true"
            //     aria-expanded="false"
            //     style={
            //       requirementLoading === "loading"
            //         ? {
            //             padding: "7px 40px",
            //           }
            //         : { color: "black", width: "auto", marginTop: "30px" }
            //     }
            //   >
            //     {requirementLoading === "loading" ? (
            //       <CircularProgress size={30} sx={{ color: "#fff" }} />
            //     ) : (
            //       changeCandidateStatus(btnsName)
            //     )}
            //   </button>
            //   <span className="dropdown-menu">
            //     {statusList.map((item, index) => (
            //       <a
            //         key={item.key}
            //         className={`dropdown-item ${
            //           index <= getSelectedIndex() ? styles.disabled : ""
            //         }`}
            //         onClick={() =>
            //           index > getSelectedIndex() && handleSelect(item.key)
            //         }
            //       >
            //         {item.label}
            //       </a>
            //     ))}
            //   </span>
            // </span>
            <button
              onClick={() => {
                handleShowCandidateDetails();
                setCandidateData(candidate);
                setJobDetailsData(row);
              }}
              style={
                requirementLoading === "loading"
                  ? {
                      padding: "7px 40px",
                    }
                  : {
                      backgroundColor: buttonColor,
                      alignSelf: "flex-end",
                      marginTop: "30px",
                    }
              }
            >
              {requirementLoading === "loading" ? (
                <CircularProgress size={30} sx={{ color: "#fff" }} />
              ) : (
                "View"
              )}
            </button>
          )}
        </span>
      </Box>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ textAlign: "center" }}
          >
            <b>Change Candidate Status </b>
          </DialogTitle>
          <DialogContent sx={{ textAlign: "center" }}>
            Are you sure you want to change status of{" "}
            <b> {candidate?.candidate_full_name}</b> to
            <b> {changeCandidateStatus(btnsName)}</b>
          </DialogContent>
          <Box>
            <Box className={styles.adding_internal_btns}>
              <button
                sx={{ backgroundColor: "#2d73b5" }}
                onClick={handleOnClickStatusChange}
              >
                Yes
              </button>
              <button sx={{ backgroundColor: "#97B6F1" }}>No</button>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

export default SalesRecruiter;
